import { AuthApi } from '../auth/authApi';
import type {
  ApplicationResponseDTO,
  GetApplicationRequestDTO,
  UserApplicationsResponseDTO,
} from './DTOs';
import { Singleton } from '@/decorators';
import type { Result } from '@/types/result.interface';
import type { AppError } from '@/types/errors.interface';
import { wrapHttpCall } from '../utils/apiResultMapper';

/**
 * Application API (Framework Agnostic)
 * 
 * Handles application form retrieval and management.
 */
@Singleton
export class ApplicationApi extends AuthApi {
  constructor() {
    super();
  }

  async getApplication(body: GetApplicationRequestDTO): Promise<Result<ApplicationResponseDTO, AppError>> {
    return wrapHttpCall(() =>
      this.api.get<ApplicationResponseDTO>(`/ApplicationForm/${body.applicationId}`)
    );
  }

  async getUserApplications(): Promise<Result<UserApplicationsResponseDTO, AppError>> {
    return wrapHttpCall(() =>
      this.api.get<UserApplicationsResponseDTO>('/ApplicationForm')
    );
  }
}
